import { render, staticRenderFns } from "./TradingNetworksForm.vue?vue&type=template&id=59bc57ec&scoped=true&"
import script from "./TradingNetworksForm.vue?vue&type=script&lang=js&"
export * from "./TradingNetworksForm.vue?vue&type=script&lang=js&"
import style0 from "./TradingNetworksForm.vue?vue&type=style&index=0&id=59bc57ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc57ec",
  null
  
)

export default component.exports